import React from 'react';
import { useLanguage } from '../../../../i18n/LanguageContext';

const ExcelStatusModal = React.memo(({ excelModal, setExcelModal, setIsExcelLoading }) => {
  const { t } = useLanguage();

  if (!excelModal.show) return null;

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setExcelModal({ show: false })}>
      <div className="excel-modal">
        <div className="modal-header">
          <h3>{excelModal.title}</h3>
          <button className="modal-close" onClick={() => setExcelModal({ show: false })}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="excel-modal-body">
          {excelModal.type === 'error' && <i className="fas fa-times-circle error-icon"></i>}
          {excelModal.type === 'success' && <i className="fas fa-check-circle success-icon"></i>}
          {excelModal.type === 'confirm' && <i className="fas fa-exclamation-triangle warning-icon"></i>}
          {excelModal.type === 'info' && <i className="fas fa-info-circle info-icon"></i>}
          {excelModal.type === 'confirm' && <h4>{t('productList.modal.confirmationNeeded', 'Onay Gerekiyor')}</h4>}
          <p style={{ whiteSpace: 'pre-line' }}>{excelModal.message}</p>
        </div>
        <div className="excel-modal-actions">
          {excelModal.type === 'confirm' ? (
            <>
              <button className="btn-cancel" onClick={() => { setExcelModal({ show: false }); setIsExcelLoading(false); }}>
                {t('common.cancel', 'İptal')}
              </button>
              <button className="btn-save" onClick={excelModal.onConfirm}>
                {t('productList.modal.yesUpload', 'Evet, Yükle')}
              </button>
            </>
          ) : (
            <button className="btn-save" onClick={() => setExcelModal({ show: false })}>
              {t('common.ok', 'Tamam')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
});

export default ExcelStatusModal;
